import LightBulb from '../src/LightBulb/index.tsx';
export default LightBulb;
